import { Component, Inject, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import {
  BASE_PURCHASE_SERVICE,
  BasePurchaseService,
} from '../../services/base-purchase.service';
import { CreditCardService } from '../../services/credit-card.service';
import { PurchaseStepsService } from '../../services/purchase-steps.service';

@Component({
  selector: 'payment-methods',
  templateUrl: './payment-methods.component.html',
  styleUrls: ['./payment-methods.component.scss'],
  standalone: false,
})
export class PaymentMethodsComponent {
  paymentMethods = this.creditCardService.paymentMethods;
  purchase = this.purchaseService.purchase;

  @ViewChild('paymentMethodsForm')
  public paymentMethodsForm: NgForm;

  constructor(
    private creditCardService: CreditCardService,
    @Inject(BASE_PURCHASE_SERVICE)
    protected purchaseService: BasePurchaseService,
    public purchaseStepsService: PurchaseStepsService,
  ) {}

  completePayment() {
    return this.purchaseService.completePayment().then(() => {
      if (!this.purchaseService.purchase.checkoutError) {
        this.purchaseStepsService.setNextStep();
      }
    });
  }

  completeCardPayment() {
    if (!this.paymentMethodsForm.valid) {
      return;
    }

    this.purchaseService
      .validatePaymentMethod()
      .then(() => {
        return this.purchaseService.preparePaymentIntent();
      })
      .then(this.completePayment.bind(this));
  }
}
